import React from 'react';
import HomeFooter from './HomeFooter';
import './BrowseLayout.css';

// Shared shell for all browse/listing pages: same footer and background as
// the homepage. The header and side rail come from App (SiteHeader, SiteRail).
const BrowseLayout = ({ children }) => (
    <div className="gh-page">
        <main className="gh-browse">{children}</main>
        <HomeFooter />
    </div>
);

export default BrowseLayout;
